import React from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { SystemConfigureType } from 'src/Libs/shop/types'
import NormalSystemConfiguration from 'src/Libs/shop/components/SystemConfiguration/NormalSystemConfiguration/NormalSystemConfiguration'
import QntmSystemConfiguration from 'src/Libs/shop/components/SystemConfiguration/QntmSystemConfiguration/QntmSystemConfiguration'

/*
 * Renders system configuration based on URL type or redirects to homepage
 */
const SystemConfigurationEntry: React.FC = () => {
  const { type } = useParams<{ type: string }>()

  if (type === SystemConfigureType.NormalSystem) {
    return <NormalSystemConfiguration />
  }
  if (type === SystemConfigureType.QntmSystem) {
    return <QntmSystemConfiguration />
  }
  return <Navigate to="/shop/homepage" replace />
}

export default SystemConfigurationEntry
